import { createContext, useContext } from 'react'

// Lightweight access for optional controls; importing a button must not load
// persistence clients or the command palette.
export const CommandContext = createContext(null)
export function useOptionalCommands() {
  return useContext(CommandContext)
}
